// extracted by mini-css-extract-plugin
export default {"keyboard":"Keyboard_keyboard__rA1n9","row":"Keyboard_row__bMPJi","key":"Keyboard_key__DVi7N"};